const state = {
  locked: null,
}

const getters = {}

const mutations = {
  isLocked(state, value) {
    state.locked = value
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/history.js